require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-bootstrap-taste-the-bootstrap-button-color-rainbow.json") })
        }
      }, "path---front-end-libraries-bootstrap-taste-the-bootstrap-button-color-rainbow");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-bootstrap-taste-the-bootstrap-button-color-rainbow!./.cache/json/front-end-libraries-bootstrap-taste-the-bootstrap-button-color-rainbow.json
// module id = 2011
// module chunks = 231608221292675